module.exports = __webpack_public_path__ + "img/posologie-if-mathild.e832d14a.png";